import { Component, Input } from '@angular/core';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
    selector: 'app-xliff-removed',
    templateUrl: './xliff-removed.component.html',
    styleUrls: ['../drb-diff.component.css']
})
export class XliffRemovedComponent {

  @Input() public item;

  constructor(public utility: UtilityService) {}
}
